import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * An overlayable button that handles paging forward on the overlay.
 */
export default class OverlayForwardButton extends Button {
  constructor(player, options) {
    super(player, options);

    this.addClass('vjs-icon-next-item');
    this.addClass('vjs-overlay-nav-button');
    this.addClass('vjs-overlay-next-button');
    this.controlText(player.localize('Next Page of Videos'));
  }

  handleClick() {
    this.player_.trigger('controls:overlay:forward');
  }
}
